import * as d3 from 'd3';
import { Format } from './Format';
import { RectFormat } from '../../charts/interfaces';
import { LineChartData } from '../../../models/LineChartData';

const margin = 6;
const magicCoef = 4.2;

function getPreviousLength(formattedValue: string): number {
    return (formattedValue === null || formattedValue === undefined)
        ? 0
        : formattedValue.length;
}

export function renderLabel(
    selection: d3.selection.Update<RectFormat<LineChartData>>,
    stacked = false,
    ratio = 1
) {
    ratio = ratio || 1;
    selection
        .exit()
        .remove();
    const enterSeries = selection
        .enter()
        .append('g')
        .classed('value-label', true);
    enterSeries
        .append('rect');
    enterSeries.append('text');

    selection.attr('transform', (d, i) => {
        let x = d.x;
        const xmin = 10;
        if (x < xmin) {
            x = xmin;
        }

        const yOffset = ((d.item.value > 0) ? 5 * ratio : -15 * ratio);
        let y = stacked
            ? ((d.item.value < 0) ? d.y + d.height : d.y) - yOffset
            : d.y - yOffset;
        const ymin = 10 * ratio;
        if (y < ymin) {
            y = 20 * ratio; // Bring the label back into the chart
        }
        return `translate(${x + (d.offsetX || 0)},${y})`;
    });
    selection.select('rect')
        .attr('height', 15 * ratio)
        .attr('width', d => getPreviousLength(d.item.formattedValue) * magicCoef * ratio + margin * ratio)
        .attr('x', d => -getPreviousLength(d.item.formattedValue) * magicCoef * ratio / 2 - margin * ratio / 2)
        .attr('y', -11 * ratio);
    selection
        .select('text')
        .text(d => (d.item.formattedValue === null || d.item.formattedValue === undefined) ? '' : d.item.formattedValue)
        .style('fill', d => d.color);
}

export function renderStackedLabels(
    container: d3.Selection<RectFormat<LineChartData>>,
    series: Format[],
    ratio = 1
): void {
    const filteredData = series
        .filter(r => r.series.isValueLabelsVisible())
        .map(r => {
            return {
                data: r.data.filter(d => !d.stackHide),
                series: r.series
            } as Format;
        });
    const dataBound = container
        .selectAll('.labels')
        .data(filteredData);
    dataBound
        .exit()
        .remove();
    dataBound
        .enter()
        .append('g')
        .classed('labels', true)
        .classed('series-container', true)
        .style('stroke', 'none');
    dataBound.classed('hidden', d => !d.series.isVisible());
    const seriesBound = dataBound
        .selectAll('.value-label')
        .data(d => d.data);
    renderLabel(seriesBound, true, ratio);
}